module.exports = __webpack_public_path__ + "static/media/h1.24e9902b.svg";